(function () {
    "use strict";

    // @ngInject
    function NetworkModerationControllerCtor($scope, $injector, $state, $window, $location, $translate, AnalyticsService, CompanyService, ModelFactory, $timeout,
                                             NetworkManager, AppStates, moment, Enums, $stateParams, UIUtils, RepositoryService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkModerationController';
        this.AnalyticsService = AnalyticsService;
        this.$location = $location;
        this.CompanyService = CompanyService;
        this.$timeout = $timeout;
        this.$window = $window;
        this.moment = moment;
        this.$state = $state;
        this.DistTypes = Enums.OpportunityDistributionTypes;
        this.RepositoryService = RepositoryService;
        this.NetworkManager = NetworkManager;
        this.lookingFor = '';
        this.selectedVendorTypes = [];
        this.isIsoLocationGeocoded = false;
        this.isIsoLocationEverywhere = false;
        this.description = '';
        this.isIsoLocationIncomplete = true;
        this.feedLocationCoordinates = [];
        this.isFeedLocationGeocoded = false;
        this.feedLocationLabel = '';
        this.isFeedLocationInputValid = false;
        this.mapLocation = this.feedLocationLabel;
        this.currNetworkUser = this.NetworkManager.getNetworkCurrUser();
        this.AppStates = AppStates;
        this.ModelFactory = ModelFactory;
        this.UIUtils = UIUtils;
        this.opportunities = ModelFactory.newNetworkReferralsCollection();
        this.showIntro = false;
        this.loadingProjects = true;
        this.myOpportunitiesOnly = false;
        this.hasOwnOpportunities = false;
        this.allOpportunities = false;
        this.lastPage = true;
        this.pinnedObjectId = null;
        this.pinnedObject = null;
        this.isOpportunities = false;
        this.isModeration = false;

        if (this.currNetworkUser.network._id) {
            this.initUserFeed();
        } else {
            this.currNetworkUser.once('network_user_success', function networkUserFetched() {
                this.initUserFeed();
            }.bind(this));
        }

        this.isShowingShareForm = false;
        this.isShowingNotificationShared = false;
        this.notificationSharedLocation = "";

        var now = new Date();
        var oneMonthFromNow = this.moment(now).add(1, 'M').format('MMM DD, YYYY');
        this.lookingForPlaceholder = $translate.instant('NETWORK.FEED._LOOKING_FOR_PLACEHOLDER_', {date: oneMonthFromNow});
        this.vendorTypes = Enums.SupportedCreativeTypes.map(function (item) {
            return {key: item.key, text: $translate.instant(item.translationEntry)};
        });
    }

    Controllers.NetworkModerationController = Class(Controllers.BaseController, {

        constructor: NetworkModerationControllerCtor,

        initUserFeed: function initUserFeed() {
            this.isOpportunities = true;
            this.allOpportunities = true;
            this.isModeration = true;
            this.getOpportunities();
        },

        getOpportunities: function getOpportunities() {
            this.loadingProjects = true;
            // this.mapLocation = this.feedLocationLabel;


            this.NetworkManager.getOpportunitiesModerationQueue(this.opportunities)
                .then(function (res) {
                    this.loadingProjects = false;
                }.bind(this)).catch(function (err) {
                this.loadingProjects = false;
            }.bind(this));

        },

        setFeedLocation: function setFeedLocation(label, coordinates) {

            this.feedLocationLabel = label;

            if (label) {
                this.RepositoryService.persistentPut('feedLocationLabel', label);
            }
            else {
                this.RepositoryService.persistentDelete('feedLocationLabel');
            }

            if (coordinates) {
                this.feedLocationCoordinates = coordinates;
                this.RepositoryService.persistentPut('feedLocation', coordinates);
            }
        },
        flaggedOnly: function flaggedOnly(currOpportunity) {
            return currOpportunity.moderation_state == "flagged" || currOpportunity.moderation_state == "approved_flagged";
        },

        waitingForReview: function flaggedOnly(currOpportunity) {
            return currOpportunity.moderation_state == "new";
        },
    });
}());
